import dayjs from 'dayjs';
import type { PatientSex } from '@/models/patient';

export function getInitials(
  firstName: string | null,
  lastName: string | null
): string {
  const first = firstName?.charAt(0).toUpperCase() ?? '';
  const last = lastName?.charAt(0).toUpperCase() ?? '';
  return `${first}${last}`;
}

export function calculateAge(dateOfBirth: string): number {
  return dayjs().diff(dayjs(dateOfBirth), 'year');
}

export function formatDob(dateOfBirth: string): string {
  if (!dateOfBirth) return '-';
  return dayjs(dateOfBirth).format('MMM D, YYYY');
}

// BE returns sex as the long form ('MALE' / 'FEMALE' / 'OTHER'); render
// the compact single-letter form to keep the sidebar tight.
const SEX_SHORT: Record<PatientSex, string> = {
  MALE: 'M',
  FEMALE: 'F',
  OTHER: 'O',
  '': '',
};

export function formatAgeSex(dateOfBirth: string, sex: PatientSex): string {
  if (!dateOfBirth) return '-';
  const age = calculateAge(dateOfBirth);
  const short = SEX_SHORT[sex] ?? '';
  return short ? `${age}/${short}` : `${age}`;
}

export function formatHeightWeight(
  height: number | null,
  weight: number | null
): string {
  if (height == null && weight == null) return '-';
  const parts: string[] = [];
  if (height != null) parts.push(`${height} cm`);
  if (weight != null) parts.push(`${weight} kg`);
  return parts.join(' / ');
}

export function formatReferringPhysician(
  firstName: string | null,
  lastName: string | null
): string {
  if (!firstName && !lastName) return '-';
  if (!firstName) return `Dr. ${lastName}`;
  return `Dr. ${firstName.charAt(0)}. ${lastName}`;
}

export function formatStudyDate(isoDate: string): string {
  if (!isoDate) return '-';
  return dayjs(isoDate).format('MMM D, YYYY');
}
